import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ComponentFactoryResolver } from '@angular/core';

import { LoadingBarService } from '@ngx-loading-bar/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { DynamicHostDirective } from '../../directives/dynamic-host.directive';
import { DynamicHostModel } from '../../models/dynamic-host.model';
import { SharedComponentI } from '../../models/shared-component.interface';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent implements OnInit {
    @Input() dynamicModel: DynamicHostModel;
    @ViewChild(DynamicHostDirective, { static: true }) dynamicContent: DynamicHostDirective;

    title = '';

    constructor(
        public loader: LoadingBarService,
        public modalRef: BsModalRef,
    ) { }

    ngOnInit(): void {
        const modalModel = this.dynamicModel.modalModel;
        this.title = modalModel.modalConfiguration.title || '';

        const cmpFctory = modalModel.componentFactoryResolver.resolveComponentFactory(modalModel.component);
        const viewContainer = this.dynamicContent.viewContainerRef;
        viewContainer.clear();

        const cmpRef = viewContainer.createComponent(cmpFctory);
        (cmpRef.instance as SharedComponentI).data = modalModel.data;
        this.dynamicModel.instantiated = true;
    }
}
